export enum Energietraeger {
    BIOMASSE = 'BIOMASSE',
    BRAUNKOHLE = 'BRAUNKOHLE',
    GASE_FOSSIL = 'GASE_FOSSIL',
    GASE_ERDGAS = 'GASE_ERDGAS',
    STEINKOHLE = 'STEINKOHLE',
    MINERALOEL = 'MINERALOEL',
    GEOTHERMIE = 'GEOTHERMIE',
    PUMPSPEICHER = 'PUMPSPEICHER',
    LAUFWASSER = 'LAUFWASSER',
    SPEICHERWASSER = 'SPEICHERWASSER',
    KERNENERGIE = 'KERNENERGIE',
    GASE = 'GASE',
    SOLAR = 'SOLAR',
    ABFALL = 'ABFALL',
    WINDENERGIE_OFFSHORE = 'WINDENERGIE_OFFSHORE',
    WINDENERGIE_ONSHORE = 'WINDENERGIE_ONSHORE',
    SONSTIGES = 'SONSTIGES',
    BATTERIESPEICHER = 'BATTERIESPEICHER'
}

export class EnergietraegerItem {

    public key: string;
    public description: string;

    constructor(key: string, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): EnergietraegerItem[] {
        return [
            new EnergietraegerItem(Energietraeger.BIOMASSE, 'B01 = Biomasse'),
            new EnergietraegerItem(Energietraeger.BRAUNKOHLE, 'B02 = Braunkohle'),
            new EnergietraegerItem(Energietraeger.GASE_FOSSIL, 'B03 = Fossiles Gas aus Kohle gewonnen'),
            new EnergietraegerItem(Energietraeger.GASE_ERDGAS, 'B04 = Erdgas'),
            new EnergietraegerItem(Energietraeger.STEINKOHLE, 'B05 = Steinkohle'),
            new EnergietraegerItem(Energietraeger.MINERALOEL, 'B06 = Mineralöl'),
            new EnergietraegerItem(Energietraeger.GEOTHERMIE, 'B09 = Geothermie'),
            new EnergietraegerItem(Energietraeger.PUMPSPEICHER, 'B10 = Pumpspeicher'),
            new EnergietraegerItem(Energietraeger.LAUFWASSER, 'B11 = Laufwasser'),
            new EnergietraegerItem(Energietraeger.SPEICHERWASSER, 'B12 = Speicherwasser'),
            new EnergietraegerItem(Energietraeger.KERNENERGIE, 'B14 = Kernenergie'),
            new EnergietraegerItem(Energietraeger.GASE, 'B15 = Biogas'),
            new EnergietraegerItem(Energietraeger.SOLAR, 'B16 = PV'),
            new EnergietraegerItem(Energietraeger.ABFALL, 'B17 = Abfall'),
            new EnergietraegerItem(Energietraeger.WINDENERGIE_OFFSHORE, 'B18 = Wind-offshore'),
            new EnergietraegerItem(Energietraeger.WINDENERGIE_ONSHORE, 'B19 = Wind-onshore'),
            new EnergietraegerItem(Energietraeger.SONSTIGES, 'B20 = sonstige'),
            new EnergietraegerItem(Energietraeger.BATTERIESPEICHER, 'Z01 = Batteriespeicher'),
        ];
    }

}
